// extracted by mini-css-extract-plugin
export var changeIcon = "_58-4";
export var container = "_58-0";
export var divider = "_58-7";
export var externalLinkIcon = "_58-1";
export var green = "_58-5";
export var helpCircleIcon = "_58-3";
export var iconButton = "_58-2";
export var red = "_58-6";